import { computed, Injectable, signal, WritableSignal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { distinctUntilChanged, filter, map } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private readonly _breadcrumbs: WritableSignal<Array<{ label: string, url: string }>> = signal([]);

  public breadcrumbs = computed(() => this._breadcrumbs());

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects.split('?')[0]),
      distinctUntilChanged(),
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.clearBreadcrumbs();
    });
  }

  public addBreadcrumb(label: string, url: string): void {
    this._breadcrumbs.update(breadcrumbs => [...breadcrumbs, { label, url }]);
  }

  public removeLastBreadcrumb(): void {
    this._breadcrumbs.update(breadcrumbs => breadcrumbs.slice(0, -1));
  }

  public clearBreadcrumbs(): void {
    this._breadcrumbs.update(() => []);
  }
}
